import { Loading, MessagePlugin } from 'tdesign-react';
import Utils from 'common/utils';
import ShowToastScss from './ShowToast.module.scss';

const showToast = (props: { message: string; theme?: 'default' | 'loading' }) => {
  MessagePlugin.closeAll();
  const { message, theme } = props;
  let curMessage;
  if (theme === 'loading') {
    curMessage = MessagePlugin.info({
      placement: 'center',
      icon: null,
      content: (
        <>
          <Loading />
          <span>{message}</span>
        </>
      ),
      className: Utils.uniteClass(ShowToastScss.message, ShowToastScss.messageLoading),
      closeBtn: false,
      duration: 0,
    });
  } else if (message) {
    curMessage = MessagePlugin.info({
      placement: 'center',
      icon: null,
      content: message,
      className: ShowToastScss.message,
      closeBtn: false,
    });
  }

  return {
    destroy: () => {
      curMessage && MessagePlugin.close(curMessage);
    },
  };
};

export default showToast;
